const langPackLocalVersion = 1;export default langPackLocalVersion;
